import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ru from './locales/ru.json';
import uz from './locales/uz.json';
import uk from './locales/uk.json';
import tr from './locales/tr.json';
import id from './locales/id.json';
import ar from './locales/ar.json';
import fr from './locales/fr.json';
import fa from './locales/fa.json';
import vi from './locales/vi.json';
import az from './locales/az.json';
import ge from './locales/ge.json';
import kk from './locales/kk.json';
import ky from './locales/ky.json';
import tj from './locales/tj.json';
import mn from './locales/mn.json';
import sk from './locales/sk.json';
import zh from './locales/zh.json';
import pl from './locales/pl.json';
import kr from './locales/kr.json';
import pt from './locales/pt.json';

// Собираем ресурсы в объект, чтобы получить список поддерживаемых языков
const resources = {
	en: { translation: en },
	ru: { translation: ru },
	uz: { translation: uz },
	uk: { translation: uk },
	tr: { translation: tr },
	id: { translation: id },
	ar: { translation: ar },
	fr: { translation: fr },
	fa: { translation: fa },
	vi: { translation: vi },
	az: { translation: az },
	ge: { translation: ge },
	kk: { translation: kk },
	ky: { translation: ky },
	tj: { translation: tj },
	mn: { translation: mn },
	sk: { translation: sk },
	zh: { translation: zh },
	pl: { translation: pl },
	kr: { translation: kr },
	pt: { translation: pt }
};

const savedLang = localStorage.getItem('app_language');
const rawUserLang = window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code || 'en';
const normalizedUserLang = String(rawUserLang).toLowerCase().split('-')[0];
const supportedLangs = Object.keys(resources);
const initialLang = savedLang || (supportedLangs.includes(normalizedUserLang) ? normalizedUserLang : 'en');

i18n
	.use(initReactI18next)
	.init({
		resources,
		lng: initialLang,
		fallbackLng: 'en',
		interpolation: {
			escapeValue: false
		}
	});

export default i18n;
